const menuFrLang = {
  // admin menu
  'menu.MainMenu': 'Menu principal',
  'menu.SystemSettings': 'Les paramètres du système',
  'menu.Dashboard': 'Tableau de bord',
  'menu.CountryRegionCity': 'Pays, Régions, Villes',
  'menu.Regions': 'Régions',
  'menu.Countries': 'Pays',
  'menu.Cities': 'Villes',
  'menu.Emails': 'E-mails',
  'menu.EmailTemplates': `Modèles d'e-mails`,
  'menu.AdminUsers': 'Utilisateurs administrateurs',
  'menu.AccessControl': `Contrôle d'accès`,
  'menu.Partners': 'Les partenaires',
  'menu.Companies': 'Entreprises',
  'menu.Passengers': 'Passagères',
  'menu.Services': 'Services',
  'menu.Plans': 'Plans',
  'menu.SoftwareComponents': 'Composants logiciels',
  'menu.Staffs': 'Bâtons',
  'menu.Notifications': 'Avis',
  'menu.Stations': 'Gares',
  'menu.Discounts': 'Réductions',
  'menu.CompanySettings': `Paramètres de l'entreprise`,
  'menu.Subscriptions': 'Abonnements',
  'menu.Fleets': 'Flottes',
  'menu.SeatModels': 'Modèles de sièges',
  'menu.TicketClasses': 'Classes de billets',
  'menu.Buses': 'Les autobus',
  'menu.BusModels': 'Modèles de bus',
  'menu.Templates': 'Modèles',
  'menu.SmsTemplates': 'Modèles SMS',
  'menu.RoutesAndTrips': 'Itinéraires et trajets',
  'menu.Routes': 'Itinéraires',
  'menu.TicketTariffs': 'Tarifs Billets',
  'menu.TariffAgeIssues': 'Ventes à revoir',
  'menu.ControlReviews': 'Contrôles à revoir',
  'menu.CreditNotes': 'Avoirs',
  'menu.BaggageTariffs': 'Tarifs Bagages',
  'menu.Trips': 'Trajets',
  'menu.TripsCalendar': 'Calendrier des trajets',
  'menu.TripDetails': 'Détails du voyage',
  'menu.Registers': 'Caisses',
  'menu.Terminals': 'Terminaux',
  // Étape 5 (2026-11-02) : clés qui n'existaient qu'en anglais.
  'menu.Tariffs': 'Tarifs',
  'menu.Tickets': 'Billets',
  'menu.PdfTemplates': 'Modèles PDF',
  'menu.Bookings': 'Réservations',
  'menu.TicketConflict': 'Conflits de billets',
  'menu.Roles': 'Rôles',
  'menu.SellOnTheGoBookings': 'Ventes en route',
  'menu.PassengerAppSettings': 'Réglages de l\'app passagers',
  'menu.Settings': 'Réglages',
  'menu.CompanyRoles': 'Rôles de la compagnie',
  'menu.Reports': 'Rapports',
  'menu.TripStatusReport': 'État des trajets',
  'menu.CommonSetting': 'Réglages communs',
  'menu.SalesReport': 'Rapport des ventes',
  'menu.TripsReport': 'Rapport des trajets',
  'menu.TripDetailReport': 'Détail des trajets',
  'menu.TripIncomeReport': 'Recettes par trajet',
  'menu.UnEarnedRevenueReport': 'Produits constatés d\'avance',
  'menu.SaleWithGroupReport': 'Ventes par groupe',
  'menu.Advertising': 'Publicité',
  'menu.SellOnTheGoReconciliation': 'Rapprochements des ventes en route',
  'menu.PassengerAppUsers': 'Passagers',
  'menu.BaggageReconciliations': 'Rapprochements des bagages',
  'menu.ShipmentManagement': 'Gestion des colis',
};

export default menuFrLang;
